import { render, staticRenderFns } from "./webinar.vue?vue&type=template&id=16a224bf&scoped=true"
import script from "./webinar.vue?vue&type=script&lang=js"
export * from "./webinar.vue?vue&type=script&lang=js"
import style0 from "./webinar.vue?vue&type=style&index=0&id=16a224bf&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a224bf",
  null
  
)

export default component.exports